import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateReframeVideoOperationMutationVariables = Types.Exact<{
  input: Types.CreateReframeVideoOperationInput;
}>;


export type CreateReframeVideoOperationMutation = { __typename?: 'Mutation', createReframeVideoOperation?: { __typename?: 'FireflyOperationPayload', fireflyOperation?: { __typename?: 'FireflyOperation', id?: string | null, destination?: { __typename?: 'FolderAsset', id: string } | null } | null } | null };


export const CreateReframeVideoOperation = /*#__PURE__*/ gql`
    mutation CreateReframeVideoOperation($input: CreateReframeVideoOperationInput!) {
  createReframeVideoOperation(input: $input) {
    fireflyOperation {
      id
      destination {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<CreateReframeVideoOperationMutation, CreateReframeVideoOperationMutationVariables>;

          

          export const useCreateReframeVideoOperationMutation = (options?:MutationHookOptions<CreateReframeVideoOperationMutation, CreateReframeVideoOperationMutationVariables>) => useMutation(CreateReframeVideoOperation, options);
          

          export type CreateReframeVideoOperationMutationOptions = MutationHookOptions<CreateReframeVideoOperationMutation, CreateReframeVideoOperationMutationVariables>;

          

          export type CreateReframeVideoOperationMutationResult = ReturnType<typeof useCreateReframeVideoOperationMutation>[1];

          
